import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.EDIT_USER = function (state, payload) {
  state[payload[0]] = payload[1]
}

const state = {
  scRow: {
    id: null,
    company: {
      id: null,
      files: {}
    }
  },
  cond: {
    SC: { user_role: 'SC' }
  }
}
const actions = {
  doSave: ({ dispatch, state }, row) => {
    console.debug('called M0001User save')
    row.self = true
    return client.postData({ data: { save: { api: 'M0001UserService.doSave', input: row } } })
      .then((data) => {
        if (data.save.output.status === false) { throw new Error(data.save.output.message) } else {
          let output = data.save.output
          if (SysUtils.isEmpty(output.error)) {
            dispatch('doEdit', row.row.id)
            localStorage.setItem('username', state.scRow.name_zh || state.scRow.name_en || state.scRow.username)
            return false
          } else {
            return output.error
          }
        }
      }).catch((err) => { throw err })
  },
  doEdit: ({ commit }, id) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { edit: { api: 'M0001UserService.doEdit', input: { id: id } } } })
      .then((data) => {
        if (data.edit.output.status === false) { throw new Error(data.edit.output.message) } else {
          commit('EDIT_USER', ['scRow', data.edit.output])
        }
      }).catch((err) => { throw err })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
